import isFunction from "./component-library338.mjs";
import isLength from "./component-library339.mjs";
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
export {
  isArrayLike as default
};
